<div class="main-container" data-cy="insurance-create-carrier-container">
  <h3 data-cy="insurance-create-carrier-title">Add a carrier to the patient</h3>

  <mat-form-field class="carrier-input" data-cy="insurance-create-carrier-employer-field">
    <input matInput placeholder="Employer" [(ngModel)]="dataPatientInsuranceDetails.EmployerNO" name="employerNo" readonly data-cy="insurance-create-carrier-employer-input">
  </mat-form-field>

  <mat-form-field class="carrier-input" data-cy="insurance-create-carrier-group-field">
    <input matInput placeholder="Group #" [(ngModel)]="dataPatientInsuranceDetails.GroupNO" name="groupNo" readonly data-cy="insurance-create-carrier-group-input">
  </mat-form-field>

  <!-- insurance order -->
  <mat-form-field class="carrier-input" data-cy="insurance-create-carrier-order-field">
    <input matInput placeholder="Insurance Order" [(ngModel)]="dataPatientInsuranceDetails.InsuranceOrder" name="insuranceOrder" type="number" data-cy="insurance-create-carrier-order-input">
  </mat-form-field>

  <!-- coverage start -->
  <mat-form-field class="carrier-input" data-cy="insurance-create-carrier-start-field">
    <input matInput [matDatepicker]="coverageStartPicker" placeholder="Coverage start" [(ngModel)]="dataPatientInsuranceDetails.CoverageStart" name="start" data-cy="insurance-create-carrier-start-input">
    <mat-datepicker-toggle matSuffix [for]="coverageStartPicker" data-cy="insurance-create-carrier-start-toggle"></mat-datepicker-toggle>
    <mat-datepicker #coverageStartPicker data-cy="insurance-create-carrier-start-picker"></mat-datepicker>
  </mat-form-field>

  <!-- coverage end -->
  <mat-form-field class="carrier-input" data-cy="insurance-create-carrier-end-field">
    <input matInput [matDatepicker]="coverageEndPicker" placeholder="Coverage end" [(ngModel)]="dataPatientInsuranceDetails.CoverageEnd" name="end" data-cy="insurance-create-carrier-end-input">
    <mat-datepicker-toggle matSuffix [for]="coverageEndPicker" data-cy="insurance-create-carrier-end-toggle"></mat-datepicker-toggle>
    <mat-datepicker #coverageEndPicker data-cy="insurance-create-carrier-end-picker"></mat-datepicker>
  </mat-form-field>

  <!-- patient insurance number -->
  <mat-form-field class="carrier-input" data-cy="insurance-create-carrier-number-field">
    <input matInput placeholder="Insurance number" [(ngModel)]="dataPatientInsuranceDetails.PatientInsuranceNO" name="patientInsuranceNo" data-cy="insurance-create-carrier-number-input">
  </mat-form-field>

  <br />

  <button class="tdo-button tdo-close" (click)="closeRef()" color="warn" data-cy="insurance-create-carrier-cancel-button">Cancel</button>
  <button class="tdo-button tdo-save" (click)="createDataPatientInsurance()" color="primary" data-cy="insurance-create-carrier-save-button">Save</button>

</div>
